import Lozenge from "@atlaskit/lozenge";
import type {ComponentProps} from "react";

export function AnankeTempLozenge(props: ComponentProps<typeof Lozenge>) {
    return <Lozenge {...props} />;
}
